import ServiceCategory from '../models/servicecategory.model';

/**
 * Read a person service category retrieved from the backend.
 * @param {Object} o
 * @return {ServiceCategory}
 */
function readServiceCategory(o) {
  return new ServiceCategory(o.id, o.name, o.order_number);
}

export {
  readServiceCategory
};



// WEBPACK FOOTER //
// ./src/app/common/serializers/servicecategory.serializer.js